import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import venturesAPI from '../../api/ventures';
import { VentureId } from '../../api/ventures/types/Venture';
import { Button } from '../common';
import { DialogTitle } from '../common/dialog';

const useStyles = makeStyles({
  paper: {
    width: 480,
  },
  content: {
    padding: '15px 32px 0',
    overflow: 'visible',
  },
});

export interface Props {
  ventureIds: VentureId[];
  isOpen: boolean;
  onClose: () => void;
}

export function ReportLinkDialog({ ventureIds, isOpen, onClose }: Props) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);

  const handleSend = useCallback(async () => {
    try {
      setIsLoading(true);
      await venturesAPI.sendVentureQuarterlyReport(ventureIds);
      onClose();
      enqueueSnackbar('The profile update request was successfully sent', {
        variant: 'success',
      });
    } catch (error) {
      console.error('Error sending report link:', error);
      enqueueSnackbar(
        'An error occurred while sending profile update request. Please, try again.',
        { variant: 'error' },
      );
    } finally {
      setIsLoading(false);
    }
  }, [ventureIds, onClose, enqueueSnackbar]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        className: classes.paper,
        elevation: 3,
      }}>
      <DialogTitle onClose={onClose}>
        Request the Latest Quarterly Report
      </DialogTitle>
      <DialogContent data-testid='calendar-element' className={classes.content}>
        Your are about to send a temporary link to allow participants to update
        their profile.
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={onClose}
          data-testid='button-cancel'>
          Cancel
        </Button>
        <Button
          onClick={handleSend}
          disabled={isLoading}
          data-testid='button-success'>
          {isLoading ? <CircularProgress size={24} color='inherit' /> : 'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
